export const getTasks = state => state.tasks.items
export const getFilterStatus = state => state.filters.status
export const getIsLoading = state => state.tasks.isLoading
export const getError = state => state.tasks.error
export const getTheme = state => state.theme.theme